import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { StopCondition } from "../../models/StopCondition.model";
import {
  GenaralRuleField,
  Operator
} from "../../models/GenaralRuleField.model";
import StopConditionComponent from "./components/StopConditionComponent/StopConditionComponent.vue";
import { Utils } from "@/shared/utils/utils";
import { GENERAL_RULES_CONSTANTS } from "../../constants/GeneralRulesConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
Vue.use(Vuetify);
@Component({
  name: "StopConditions",
  components: {
    StopConditionComponent
  }
})
export default class StopConditions extends Vue {
  @Prop({ default: false }) private dialog!: boolean;
  @Prop({ default: () => [] }) private stopConditionsProp!: StopCondition[];
  @Prop({ default: () => [] }) private fields!: GenaralRuleField[];
  @Prop() private notificationExeRules?: boolean;

  cardClass = STYLE_CLASSES.CARD;
  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  title = GENERAL_RULES_CONSTANTS.STOP_CONDITIONS_TITLE;
  CANCEL = GENERAL_RULES_CONSTANTS.TOOLTIP.CANCEL;
  GUARDAR = GENERAL_RULES_CONSTANTS.TOOLTIP.SAVE;
  GO_TO_START = GENERAL_RULES_CONSTANTS.TOOLTIP.GO_TO_START;
  ADD_CONDITION = GENERAL_RULES_CONSTANTS.TOOLTIP.ADD_CONDITION;

  stopConditions: StopCondition[] = [];
  operators: Operator[] = [];
  showOperators = true;
  disableSaveBtn = false;
  mounted() {
    this.title = this.notificationExeRules
      ? GENERAL_RULES_CONSTANTS.TOOLTIP.EXECUTE_RULES_NOTIFICACION
      : GENERAL_RULES_CONSTANTS.STOP_CONDITIONS_TITLE;
  }
  @Watch("dialog")
  setData() {
    this.title = this.notificationExeRules
      ? GENERAL_RULES_CONSTANTS.TOOLTIP.EXECUTE_RULES_NOTIFICACION
      : GENERAL_RULES_CONSTANTS.STOP_CONDITIONS_TITLE;
    if (this.dialog) {
      if (this.stopConditionsProp.length > 0)
        this.stopConditions = [...this.stopConditionsProp];
      else this.addCondition();
    }
  }

  cleanStopConditions() {
    this.stopConditions = [];
    this.operators = [];
  }

  addCondition() {
    this.stopConditions.push({
      key: "",
      operator: "",
      value: "",
      active: true
    });
  }

  onDeleteStopConditions(index: number) {
    this.stopConditions.splice(index, 1);
    if (this.stopConditions.length == 0) {
      this.addCondition();
      this.onEnableSaveBtn();
    } else {
      let disableSaveBtn = true;
      this.stopConditions.forEach(condition => {
        if (condition.value) disableSaveBtn = false;
        else disableSaveBtn = true;
      });
      this.disableSaveBtn = disableSaveBtn;
    }
  }

  saveStopConditions() {
    this.stopConditions = this.stopConditions.filter(
      condition => condition.key
    );
    const exist = this.validateIsFieldExist();
    if (exist > 0) {
      Snackbar.popError(GENERAL_RULES_CONSTANTS.MESSAGES.FIELD_DUPLICATE);
    } else {
      !this.notificationExeRules
        ? this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.SAVE_STOP_CONDITIONS, [
            ...this.stopConditions
          ])
        : this.$emit(
            GENERAL_RULES_CONSTANTS.EMITTERS.SAVE_NOTIFICATION_EXE_RULE,
            [...this.stopConditions]
          );
      this.cleanStopConditions();
    }
  }

  goToStart(component: string) {
    Utils.scrollToElement(component, this);
  }

  closeModal() {
    this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.CLOSE_MODAL);
    this.cleanStopConditions();
  }

  onAddStopCondition(stopCondition: StopCondition) {
    this.stopConditions.push(stopCondition);
  }

  onUpdateStopCondition(stopCondition: StopCondition, index: number) {
    this.stopConditions[index] = stopCondition;
  }

  onDisableSaveBtn() {
    this.disableSaveBtn = true;
  }

  onEnableSaveBtn() {
    this.disableSaveBtn = false;
  }

  validateIsFieldExist() {
    const shearch = this.stopConditions.reduce(
      (acc: any, condition: StopCondition) => {
        acc[condition.key] = ++acc[condition.key] || 0;
        return acc;
      },
      {}
    );

    const duplicates = this.stopConditions.filter(condition => {
      return shearch[condition.key];
    });

    return duplicates.length;
  }
}
